import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface ProductScreenshotSlide {
  src: string;
  altKey: string;
}

@Component({
  selector: 'app-product-screenshot',
  templateUrl: './product-screenshot.component.html',
  styleUrls: ['./product-screenshot.component.scss'],
})
export class ProductScreenshotComponent {
  @Input() src = '';
  @Input() altKey = '';
  @Input() slides: ProductScreenshotSlide[] = [];
  @Input() slideIndex = 0;
  @Output() imageError = new EventEmitter<Event>();

  isOpen = false;
  currentIndex = 0;

  get resolvedSlides(): ProductScreenshotSlide[] {
    if (this.slides.length) {
      return this.slides;
    }
    return [{ src: this.src, altKey: this.altKey }];
  }

  get currentSlide(): ProductScreenshotSlide {
    return this.resolvedSlides[this.currentIndex] ?? this.resolvedSlides[0];
  }

  get hasPrev(): boolean {
    return this.currentIndex > 0;
  }

  get hasNext(): boolean {
    return this.currentIndex < this.resolvedSlides.length - 1;
  }

  open(): void {
    this.currentIndex = Math.min(Math.max(this.slideIndex, 0), this.resolvedSlides.length - 1);
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
  }

  close(): void {
    this.isOpen = false;
    document.body.style.overflow = '';
  }

  prev(): void {
    if (this.hasPrev) {
      this.currentIndex -= 1;
    }
  }

  next(): void {
    if (this.hasNext) {
      this.currentIndex += 1;
    }
  }

  onError(event: Event): void {
    this.imageError.emit(event);
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (!this.isOpen) {
      return;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.prev();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.next();
    }
  }
}
